var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { nulledScopeSelection, } from "../types/dataModels";
export var DEFAULT_SEARCH_PARAMS = {
    keyword: ['asset_Name'],
    match_operator: 'contains',
    block_operator: 'OR',
};
var activeSelectionReducer = function (items, action) {
    switch (action.type) {
        case 'SELECT_SCOPE': {
            var newItems = __assign(__assign({}, items), { coll: null, scpp: __assign({}, action.item), fltr: null });
            return newItems;
        }
        case 'SELECT_COLLECTION': {
            var newItems = __assign(__assign({}, items), { pendingDynamicHydration: null, scpp: null, coll: __assign({}, action.item), fltr: null });
            return newItems;
        }
        case 'REQUEST_DYNAMIC_HYDRATION': {
            return __assign(__assign({}, items), { pendingDynamicHydration: __assign({}, action.item), scpp: null, coll: { type: 'dynamic', id: action.item.id }, fltr: null });
        }
        case 'CLEAR_DYNAMIC_HYDRATION': {
            return __assign(__assign({}, items), { pendingDynamicHydration: null });
        }
        case 'SELECT_SEARCH': {
            var normalizedTags = Array.isArray(action.item.tags)
                ? action.item.tags
                    .map(function (tag) { return (typeof tag === 'string' ? tag.trim() : ''); })
                    .filter(function (tag) { return tag !== ''; })
                : [];
            var searchVal = null;
            if (normalizedTags.length > 0) {
                searchVal = {
                    tags: normalizedTags,
                    params: action.item.params || DEFAULT_SEARCH_PARAMS,
                };
            }
            var scppVal = items.scpp;
            if (!(items === null || items === void 0 ? void 0 : items.coll) && !(items === null || items === void 0 ? void 0 : items.scpp)) {
                scppVal = nulledScopeSelection;
            }
            var newItems = __assign(__assign({}, items), { scpp: scppVal, srch: searchVal });
            return newItems;
        }
        case 'SELECT_FILTER': {
            var newItems = __assign(__assign({}, items), { fltr: action.item ? __assign({}, action.item) : null });
            return newItems;
        }
        case 'HYDRATE_FROM_URL': {
            return __assign(__assign({}, action.item), { pendingDynamicHydration: null });
        }
        case 'ACTIVATE_SAVED_SEARCH': {
            return __assign(__assign({}, items), { saved_search: action.item });
        }
        default: {
            var exhaustiveCheck = action;
            throw Error("ActiveSelectionReducer: Unhandled action ".concat(String(exhaustiveCheck)));
        }
    }
};
export default activeSelectionReducer;
